module.exports = __webpack_public_path__ + "static/media/interiorImage2-min.fb268d64.jpg";